
export default function OrderDetailsPage() {
  return (
    <div>OrderDetailsPage</div>
  )
}
